module.exports = __webpack_public_path__ + "img/5.1dd7831e.svg";